import { render, staticRenderFns } from "./ChildResources.vue?vue&type=template&id=25e719b7&scoped=true&"
import script from "./ChildResources.vue?vue&type=script&lang=js&"
export * from "./ChildResources.vue?vue&type=script&lang=js&"
import style0 from "./ChildResources.vue?vue&type=style&index=0&id=25e719b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e719b7",
  null
  
)

export default component.exports